import React, { useState } from "react";
import { Modal, Form, Input, Switch, Button, Space } from "antd";
import { formatDate } from "../../components/Customs/dateFormatter";
import { GeneralService } from "../../Services/GeneralService";
import { notify } from "../../components/Customs/NotifyProvider";

const CreateVendorModal = ({ open, onClose, onSuccess }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (values) => {
        try {
            setLoading(true);

            const newVendor = {
                ...values,
                created_at: formatDate(),
                updated_at: formatDate(),
            };

            const req = await GeneralService.create("vendors", newVendor);

            if (req.status) {
                notify.success(req.message);
                form.resetFields();
                onSuccess && onSuccess(); // refresh parent list
                onClose();
            } else {
                notify.error(req.message);
            }
        } catch (error) {
            console.error(error);
            notify.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Add Vendor"
            open={open}
            onCancel={onClose}
            footer={null}
            destroyOnClose
        >
            <Form layout="vertical" form={form} onFinish={handleSubmit}>
                <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>

                <Form.Item name="phone" label="Phone" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>

                <Form.Item name="email" label="Email">
                    <Input />
                </Form.Item>

                <Form.Item name="address" label="Address">
                    <Input.TextArea />
                </Form.Item>

                <Form.Item
                    name="is_active"
                    label="Active"
                    valuePropName="checked"
                    initialValue={true}
                >
                    <Switch />
                </Form.Item>

                <Space>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Create
                    </Button>
                </Space>
            </Form>
        </Modal>
    );
};

export default CreateVendorModal;